import React from 'react';
import BaseIcon, { IIconProps, getIconDimension } from '../../BaseIcon';
import { getColor } from '../../colors';

const AccountIconFilled: React.FC<IIconProps> = ({
  size = 'medium',
  width,
  height,
  color = 'currentColor',
  secondaryColor = 'color1',
  ...props
}) => {
  const iconDimension = getIconDimension(size);

  return (
    <BaseIcon
      viewBox="0 0 24 24"
      width={width || iconDimension}
      height={height || iconDimension}
      fill="none"
      color={getColor(color)}
      {...props}
    >
      <path
        d="M23 22.1323H1L2.83333 19.1323L6.5 16.7323L8.94444 15.5323L5.27778 11.9323L4.66667 7.73226L6.5 3.53226L10.7778 1.13226L13.8333 1.73226L17.5 3.53226L19.3333 7.73226L18.1111 12.5323L15.0556 15.5323L21.1667 19.1323L23 22.1323Z"
        fill={getColor(secondaryColor)}
      />
      <path
        d="M23.8639 21.7328C22.1083 18.708 19.4029 16.539 16.2455 15.5109C17.8073 14.5843 19.0207 13.1725 19.6994 11.4922C20.378 9.81182 20.4845 7.95593 20.0023 6.20948C19.5202 4.46303 18.4761 2.92259 17.0305 1.82472C15.5849 0.726853 13.8176 0.132263 12 0.132263C10.1824 0.132263 8.41515 0.726853 6.9695 1.82472C5.52385 2.92259 4.47979 4.46303 3.99765 6.20948C3.51552 7.95593 3.62196 9.81182 4.30065 11.4922C4.97933 13.1725 6.19272 14.5843 7.75448 15.5109C4.59714 16.5379 1.89168 18.7068 0.136064 21.7328C0.071683 21.8374 0.0289793 21.9538 0.0104728 22.0751C-0.00803369 22.1964 -0.00196803 22.3202 0.0283119 22.4392C0.0585918 22.5582 0.112473 22.6699 0.186775 22.7677C0.261078 22.8656 0.354297 22.9477 0.460934 23.009C0.56757 23.0704 0.685463 23.1099 0.807656 23.1251C0.92985 23.1404 1.05387 23.1311 1.1724 23.0978C1.29092 23.0645 1.40156 23.0079 1.49777 22.9313C1.59399 22.8547 1.67384 22.7596 1.7326 22.6518C3.90435 18.9113 7.74295 16.6781 12 16.6781C16.257 16.6781 20.0956 18.9113 22.2674 22.6518C22.3262 22.7596 22.406 22.8547 22.5022 22.9313C22.5984 23.0079 22.7091 23.0645 22.8276 23.0978C22.9461 23.1311 23.0701 23.1404 23.1923 23.1251C23.3145 23.1099 23.4324 23.0704 23.5391 23.009C23.6457 22.9477 23.7389 22.8656 23.8132 22.7677C23.8875 22.6699 23.9414 22.5582 23.9717 22.4392C24.002 22.3202 24.008 22.1964 23.9895 22.0751C23.971 21.9538 23.9283 21.8374 23.8639 21.7328ZM5.54469 8.40672C5.54469 7.13434 5.92329 5.89054 6.63261 4.83259C7.34193 3.77465 8.35011 2.95008 9.52966 2.46316C10.7092 1.97625 12.0072 1.84885 13.2594 2.09708C14.5116 2.3453 15.6618 2.95801 16.5646 3.85772C17.4674 4.75743 18.0822 5.90372 18.3313 7.15165C18.5804 8.39958 18.4525 9.6931 17.9639 10.8686C17.4753 12.0441 16.6479 13.0489 15.5864 13.7558C14.5248 14.4627 13.2767 14.84 12 14.84C10.2885 14.8382 8.64764 14.1598 7.43743 12.9537C6.22722 11.7476 5.54652 10.1124 5.54469 8.40672Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

export default AccountIconFilled;
